import React from "react";
import PropTypes from "prop-types";
import BreadcrumbBar from "widgets/BreadcrumbBar";

export default function Breadcrumb({ stepNames, currentStep = 0, numSelected = 0 }){
	const title = stepNames.map((step, index) => {
		return `${step} ${index === stepNames.length -1 && numSelected > 0 ? `(${numSelected})` : ""}`;
	});

	return (
		<BreadcrumbBar
			stepNames = {title}
			currentStep = {currentStep}
		/>
	);
}

Breadcrumb.displayName = "DisplayConceptBreadcrumb";
Breadcrumb.propTypes = {
	currentStep: PropTypes.number,
	numSelected: PropTypes.number,
};
